var _g, _circle, _g2, _g3, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconeZikaMicrocefalia = function SvgIconeZikaMicrocefalia(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_14652_32181)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 17,
    r: 16,
    fill: "#9BE1D8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_14652_32181",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 5,
    width: 24,
    height: 24
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 17,
    r: 12,
    fill: "#C4C4C4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_14652_32181)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_14652_32181)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.3362 14.2912C20.9041 13.5103 20.546 11.6882 20.546 10.8747C23.7684 11.2652 26.1851 11.5644 26.6327 16.4874L23.4998 16.935C24.0819 15.8683 24.3792 14.8637 24.0819 14.8375C23.5865 14.7938 22.9826 14.6436 22.3362 14.2912Z",
    fill: "#DBF6F2"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_14652_32181)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1881 11.3707C22.6894 11.82 24.8424 12.4644 24.8424 13.3548C24.8424 14.7021 26.185 15.145 27.0801 14.6975C27.9752 14.2499 27.9752 12.9073 27.0801 12.2228C27.0801 11.3277 27.0801 9.08476 24.3948 8.18976C22.1424 7.43902 20.8346 9.06905 20.4715 10.4012C20.3576 10.8194 20.6442 11.2077 21.0594 11.3321C21.1017 11.3448 21.1446 11.3577 21.1881 11.3707ZM23.8043 16.4175C24.336 15.9232 25.1434 15.1727 26.1851 15.7978C27.4352 16.548 27.0092 17.5774 26.4678 18.8861C26.0399 19.9201 25.54 21.1285 25.7375 22.5113C25.9324 23.8753 26.2687 25.0336 26.6309 25.9023C27.0219 26.8397 27.0628 28.0444 26.2538 28.6585C24.797 29.7643 22.515 30.7018 19.9194 29.6636C15.4439 27.8734 16.7866 22.5113 19.4719 20.7126C19.1735 20.1159 18.9348 18.7518 20.367 18.0358C21.0519 17.6933 21.3984 17.6369 21.7023 17.5874C22.1224 17.519 22.4611 17.4638 23.4998 16.6847C23.5883 16.6184 23.6899 16.5239 23.8043 16.4175Z",
    fill: "#02786D"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_14652_32181)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.1851 19.3782C26.5431 16.8719 26.6326 16.2454 24.8425 16.2454C23.0523 16.2454 23.9474 19.9749 23.9474 21.6159C23.0523 21.1684 21.7096 21.1684 20.8145 21.1684C19.9194 21.1684 19.9194 20.7208 19.0243 20.7208C18.1292 20.7208 17.2341 22.0635 17.2341 22.9586C17.2341 23.8537 19.4719 22.7532 20.367 22.7532C21.2621 22.7532 22.1572 23.8537 24.3949 23.8537C26.6326 23.8537 25.7375 22.511 26.1851 19.3782Z",
    fill: "#DBF6F2"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_14652_32181)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 14L10.3334 16.6667H9.00004L8.33337 18.6667",
    stroke: "#50BBAF",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 16.6667L10.8667 19.3334H10.0667L9.66675 21.3334",
    stroke: "#50BBAF",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 14L14.3334 16.6667H15.6667L16.3334 18.6667",
    stroke: "#50BBAF",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 16.6667L13.8 19.3334H14.6L15 21.3334",
    stroke: "#50BBAF",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 15.3334L10.2 12.6667H9.4L9 10.6667",
    stroke: "#50BBAF",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6667 15.3334L14.4667 12.6667H15.2667L15.6667 10.6667",
    stroke: "#50BBAF",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.3333,
    cy: 18.0001,
    rx: 2.66667,
    ry: 1.33333,
    transform: "rotate(-90 12.3333 18.0001)",
    fill: "#00443D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.3333,
    cy: 14.6667,
    r: 0.801953,
    fill: "#02786D",
    stroke: "#02786D",
    strokeWidth: 1.06276
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.89166 13.283C9.19525 13.6233 12.0214 14.8246 11.8747 15.3581C11.728 15.8916 8.66399 15.5552 7.36039 15.2148C6.05679 14.8745 5.11895 14.1661 5.26565 13.6327C5.41236 13.0992 6.58806 12.9426 7.89166 13.283Z",
    fill: "#DBF6F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7751 13.283C15.4715 13.6233 12.6454 14.8246 12.7921 15.3581C12.9388 15.8916 16.0028 15.5552 17.3064 15.2148C18.61 14.8745 19.5478 14.1661 19.4011 13.6327C19.2544 13.0992 18.0787 12.9426 16.7751 13.283Z",
    fill: "#DBF6F2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.3334,
    cy: 13.3334,
    r: 0.666667,
    fill: "#02786D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2671 10.5964L12 13H12.6667L12.3996 10.5964C12.3908 10.5173 12.2759 10.5173 12.2671 10.5964Z",
    fill: "#02786D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_14652_32181",
    x: 0,
    y: 0,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.313726 0 0 0 0 0.733333 0 0 0 0 0.686275 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14652_32181"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14652_32181",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_14652_32181",
    x: 19.539,
    y: 9.86774,
    width: 8.10064,
    height: 8.07424,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.503492
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.211765 0 0 0 0 0.627451 0 0 0 0 0.580392 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14652_32181"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14652_32181",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_14652_32181",
    x: 15.993,
    y: 6.99302,
    width: 12.7654,
    height: 24.1275,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.503492
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.266667 0 0 0 0 0.239216 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14652_32181"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14652_32181",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_14652_32181",
    x: 16.2271,
    y: 15.2384,
    width: 11.1738,
    height: 9.62227,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.503492
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.211765 0 0 0 0 0.627451 0 0 0 0 0.580392 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14652_32181"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14652_32181",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_14652_32181",
    x: 4.25049,
    y: 9.33331,
    width: 16.1658,
    height: 13.3335,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.368627 0 0 0 0 0.333333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14652_32181"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14652_32181",
    result: "shape"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconeZikaMicrocefalia, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icone-zika-microcefalia.90c44580.svg";
export { ForwardRef as ReactComponent };